<template lang="html">
    <div></div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped></style>

<script>
import Cookie from "js-cookie";
export default {
    name: "logout",
    data() {
        return {
            oWebViewInterface: window.nsWebViewInterface,
        };
    },
    created() {
        Cookie.remove(process.env.VUE_APP_AUTH_COOKIE_NAME);
        this.$store.dispatch("resetState");
        this.oWebViewInterface.emit("logOut");
        this.$router.push("/login?home=show");
    },
};
</script>
